import pino from 'pino';
import { LOGGER_LEVEL } from 'app/constants/env';

export const logger = pino({
  level: LOGGER_LEVEL || 'info',
});
